<app-q-select
  label="object"
  [options]="objects$ | async"
  [ngModel]="value"
  (ngModelChange)="onClick($event)"
  [disabled]="disabled"
  [invalid]="invalid"
  [inline]="inline"
></app-q-select>
